import React from "react";
import user from "src/assets/user.png";
import userHover from "src/assets/user_hover.png";
import settings from "src/assets/settings.png";
import settingsHover from "src/assets/settings_hover.png";
import help from "src/assets/question.png";
import logout from "src/assets/log-out.png";
import logoutHover from "src/assets/log-out_hover.png";
import orders from "src/assets/orders.png";
import ordersHover from "src/assets/orders_hover.png";
import wishlist from "src/assets/wishlist.png";
import wishlistHover from "src/assets/wishlist_hover.png";
import closebutton from "src/assets/close-button.png";
import profileimg from "src/assets/profile.jpg";
// import "src/index.css";
import { useNavigate } from "react-router";
import i18n from "src/components/util/languageResource";
import { useState, useEffect, useRef } from "react";
import { Divider, MenuItem, Select } from "@mui/material";
import UseCustomerProfileMenu from "./useCustomerProfileMenu";
import { LOGOUT } from "src/components/helper/constants";
import { logout as logoutAction, selectAuth } from "src/store/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { clearCartCount } from "src/redux/cart/cartSlice";
import { AppDispatch } from "src/store/store";
import { nextLocalStorage } from "src/components/api/helper/apiHelper";

interface DropdownItemProps {
  img: string;
  text: string;
  hoverImg?: string;
  onClick?: () => void;
}

const CustomerProfileMenu = () => {
  const {} = UseCustomerProfileMenu();

  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userInfo = useSelector(selectAuth);
  const [UserAvaterImagePath] = useState(userInfo.user?.ProfileImagePath);
  const auth = useSelector(selectAuth);
  const handlelogout = () => {
    dispatch(logoutAction());
    dispatch(clearCartCount());
    nextLocalStorage()?.removeItem("SignInUser");
    LOGOUT();
  };

  const [open, setOpen] = useState(false);
  let menuRef = useRef<HTMLDivElement>(null);

  const handleCustomerAccountClick = () => {
    navigate("/MyAccount");
  };
  const handleOrderHistoryClick = () => {
    navigate("/OrderHistory");
  };
  const handleCustomerWishlistClick = () => {
    navigate("/Wishlist");
  };
  const handleAccountSettingsClick = () => {
    navigate("/AccountSettings");
  };

  const languageOptions = [
    { value: "en", label: "English" },
    // { value: "hn", label: "हिंदी" },
    // { value: "mr", label: "मराठी" },
    // Add more languages as needed
  ];

  const changeLanguage = (selectedLanguage: string) => {
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("selectedLanguage", selectedLanguage); // Store selected language in local storage
  };

  useEffect(() => {
    let handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  useEffect(() => {
    // Check if a language is stored in local storage, if so, initialize i18n with that language
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage && i18n.language !== storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  return (
    <div className="customerprofilemenu">
      <div className="profilemenu-container" ref={menuRef}>
        <div
          className="customerprofilemenu-trigger"
          onClick={() => setOpen(!open)}
        >
          <img
            src={
              UserAvaterImagePath != process.env.REACT_APP_API_URL
                ? UserAvaterImagePath
                : "/defaultProfile.jpg"
            }
          />
        </div>

        <div
          className={`customerprofilemenu-dropdown-menu ${
            open ? "active" : "inactive"
          }`}
          style={{
            border: "1px solid transparent",
            background:
              "linear-gradient(#0A0A0B, #0A0A0B) padding-box, radial-gradient(circle at top center, #fff -10%, #373737 30%) border-box",
          }}
        >
          <div
            style={{
              padding: "20px",
            }}
          >
            <div className="closebutton">
              <a href="#">
                <img
                  src={closebutton}
                  alt="Close Button"
                  onClick={() => setOpen(!open)}
                />
              </a>
            </div>
            <div className="customerprofileouter">
              <div className="customerprofileimg">
                <img
                  src={
                    UserAvaterImagePath != process.env.REACT_APP_API_URL
                      ? UserAvaterImagePath
                      : "/defaultProfile.jpg"
                  }
                />
              </div>
            </div>
            <div className="customerprofilename">
              <h3 style={{ color: "#ffffff", marginBottom:'16px', }}>{auth.user?.PersonName}</h3>
              {/* <p style={{ color: "#a5a5a5" }}>
                <span>{auth.user?.UserRole}</span>
              </p> */}
              {/* <h6 style={{ color: "#a5a5a5" }}>
                {" "}
                Employee ID :{" "}
                <span style={{ color: "#ffffff" }}>
                  {auth.user?.EmployeeID}
                </span>
              </h6> */}

              <h6 style={{ color: "#a5a5a5" }}>
                <span style={{ color: "#ffffff" }}>
                  {auth.user?.Department}
                </span>
              </h6>
              <p style={{ color: "#a5a5a5" }}>
                <span style={{ color: "#ffffff" }}>
                  {auth.user?.Designation}
                </span>
              </p>
            </div>

            {/* <div className="languagebox">
              <div>
                <h6>{"Select Language"}</h6>
              </div>
              <div>
                <Select
                  labelId="language-select-label"
                  id="language-select"
                  value={i18n.language}
                  label={"Language"}
                  onChange={(e) => changeLanguage(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        // Remove padding from the Menu List
                        "& .MuiList-root": {
                          paddingTop: 0,
                          paddingBottom: 0,
                        },
                      },
                    },
                  }}
                  sx={{
                    color: "#A5A5A5",
                    "& fieldset": {
                      border: "none",
                    },
                    "& .MuiSelect-select": {
                      padding: "0px",
                      marginBottom: "10px",
                    },
                    "& .MuiSelect-icon": {
                      marginTop: "-5px",
                      color: "#A5A5A5",
                    },
                  }}
                >
                  {languageOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{
                        background: "#202328",
                        color: "#A5A5A5",
                        transition: "background 0.3s",
                        "&:hover": {
                          backgroundColor: "#F6FF00 !important",
                          color: "#000",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#F6FF00 !important",
                          color: "#000",
                        },
                        "&.Mui-selected:hover": {
                          backgroundColor: "#F6FF00 !important",
                          color: "#000",
                        },
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div> */}

            <ul className="profilemenu-ul">
              <ProfileDropdownItem
                img={user}
                text={"My Account"}
                hoverImg={userHover}
                onClick={handleCustomerAccountClick}
              />
              <ProfileDropdownItem
                img={orders}
                text={"My Orders"}
                hoverImg={ordersHover}
                onClick={handleOrderHistoryClick}
              />
              <ProfileDropdownItem
                img={wishlist}
                text={"My Wishlist"}
                hoverImg={wishlistHover}
                onClick={handleCustomerWishlistClick}
              />
              {/* <ProfileDropdownItem
                img={settings}
                text={"Settings"}
                hoverImg={settingsHover}
                onClick={handleAccountSettingsClick}
              /> */}
              {/* <ProfileDropdownItem img={help} text={"Help"} /> */}
              <Divider
                sx={{
                  my:1,
                  borderBottom: "1px solid #242424",
                }}
              />
              <ProfileDropdownItem
                img={logout}
                text={"Logout"}
                hoverImg={logoutHover}
                onClick={() => handlelogout()}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfileDropdownItem = (props: DropdownItemProps) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleCustomerAccountClick = (e: React.MouseEvent) => {
    e.preventDefault(); // prevent page refresh
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <li className="profilemenu-dropdownItem">
      <a
        href=""
        onClick={handleCustomerAccountClick}
        className="userprofilemenu"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <img
          src={isHovered && props.hoverImg ? props.hoverImg : props.img}
          alt={props.text}
        />
        {props.text}
      </a>
    </li>
  );
};

// const ProfileDropdownItem = (props: DropdownItemProps) => {
//   const handleCustomerAccountClick = () => {
//     if (props.onClick) {
//       props.onClick(); // Call the onClick handler if it exists
//     }
//   };
//   return (
//     <>
//       <li className="profilemenu-dropdownItem">
//         <a
//           href=""
//           onClick={handleCustomerAccountClick}
//           className="userprofilemenu"
//         >
//           <img src={props.img} alt={props.text} />
//           {props.text}
//         </a>
//       </li>
//     </>
//   );
// };

export default CustomerProfileMenu;
